export const Header = () => {
  return (
    <div className="header" style={{ color: "darkBlue" }}>
      <h1>
        <i class="fa-solid fa-envelope"></i> Sudipta's Mail Box
      </h1>
    </div>
  );
};
